import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { i18n } from "@lingui/core";
import { f as formatI18nCurrency } from "./price-COKjAhbU.js";
const toPenaltiesInfographicStep = (t, languageCode, currency, cancellationAdminFee) => (period, index, array) => {
  const prevPeriod = array[index - 1] || {};
  const {
    validUntilDaysBeforeDeparture = void 0
  } = prevPeriod;
  const {
    color,
    label
  } = formatPeriod(t, languageCode, period, currency, index == 0 ? cancellationAdminFee : void 0, true) || {};
  return {
    key: index.toString(),
    dayLabel: validUntilDaysBeforeDeparture ? i18n._( /*i18n*/
    {
      id: "WmjBed",
      message: "{validUntilDaysBeforeDeparture, plural, one {# DAY} other {# DAYS}}",
      values: {
        validUntilDaysBeforeDeparture
      }
    }) : void 0,
    color,
    label
  };
};
const formattedAdministrativeFeeDisclaimer = (t, languageCode, value, currency) => {
  if (!value || !currency) return void 0;
  const amount = formatI18nCurrency(value.amount, currency, languageCode);
  if (value.amount <= 0) return void 0;
  switch (value.type) {
    case "fixedAmountPerBooking":
      {
        return t( /*i18n*/
        {
          id: "administrative-fee-per-booking-disclaimer",
          message: "*Includes a {amount} administrative fee per booking, which will be automatically converted to a Future Cruise Credit (FCC)",
          values: {
            amount
          }
        });
      }
    case "fixedAmountPerPerson":
      {
        return t( /*i18n*/
        {
          id: "administrative-fee-per-person-disclaimer",
          message: "*Includes a {amount} administrative fee per person, which will be automatically converted to a Future Cruise Credit (FCC)",
          values: {
            amount
          }
        });
      }
  }
};
const penaltyPercentageColor = percentage => percentage === 0 ? "green" : percentage === 100 ? "red" : "yellow03";
function formatPeriod(t, languageCode, period, currency, cancellationAdminFee) {
  let formatted = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  const refundableLabel = t( /*i18n*/
  {
    id: "Q4nzLn",
    message: "refundable"
  });
  const formatter = formatted ? buildFormattedLabel : buildLabel;
  if (period.type === "Deposit") return {
    label: /* @__PURE__ */jsxs(Fragment, {
      children: ["Deposit", /* @__PURE__ */jsx("br", {}), "refundable*"]
    }),
    color: "yellow03"
  };
  if (period.type == "NonRefundable") return {
    label: formatter(t( /*i18n*/
    {
      id: "WMdQfg",
      message: "Not"
    }), refundableLabel, cancellationAdminFee),
    color: "red"
  };
  const penalty = period.penalty;
  switch (penalty.type) {
    case "percentage":
      return {
        color: penaltyPercentageColor(penalty.percentage),
        label: formatter("".concat(100 - penalty.percentage, "%"), refundableLabel, cancellationAdminFee)
      };
    case "percentageWithMaximumAmount":
      return {
        color: penaltyPercentageColor(penalty.percentage),
        label: penalty.percentage == 100 ? formatter(t( /*i18n*/
        {
          id: "WMdQfg",
          message: "Not"
        }), refundableLabel, cancellationAdminFee) : formatter("".concat(100 - penalty.percentage, "%"), "refundable up to ".concat(formatI18nCurrency(penalty.maxAmount, currency, languageCode)), cancellationAdminFee)
      };
    case "fixedAmountPerBooking":
      return {
        color: "green",
        label: formatter(formatI18nCurrency(penalty.amount, currency, languageCode), "per booking", cancellationAdminFee)
      };
    case "fixedAmountPerPerson":
      return {
        color: "green",
        label: formatter(formatI18nCurrency(penalty.amount, currency, languageCode), "per person", cancellationAdminFee)
      };
  }
}
const buildFormattedLabel = (prefix, suffix, cancellationAdminFee) => {
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsxs("big", {
      children: [prefix, cancellationAdminFee !== null && cancellationAdminFee !== void 0 && cancellationAdminFee.amount ? "*" : ""]
    }), " ", suffix]
  });
};
const buildLabel = (prefix, suffix, cancellationAdminFee) => {
  return "".concat(prefix).concat(cancellationAdminFee !== null && cancellationAdminFee !== void 0 && cancellationAdminFee.amount ? "*" : "", " ").concat(suffix);
};
const firstPeriodIsTypeDeposit = paymentTerms => {
  var _paymentTerms$cancell;
  return ((_paymentTerms$cancell = paymentTerms.cancellationPeriods) === null || _paymentTerms$cancell === void 0 || (_paymentTerms$cancell = _paymentTerms$cancell[0]) === null || _paymentTerms$cancell === void 0 ? void 0 : _paymentTerms$cancell.type) === "Deposit";
};
const currentCancellationPeriodOrFirst = terms => {
  var _terms$cancellationPe;
  return "currentCancellationPeriod" in terms ? terms.currentCancellationPeriod : (_terms$cancellationPe = terms.cancellationPeriods) === null || _terms$cancellationPe === void 0 ? void 0 : _terms$cancellationPe[0];
};
export { formattedAdministrativeFeeDisclaimer as a, formatPeriod as b, currentCancellationPeriodOrFirst as c, firstPeriodIsTypeDeposit as f, toPenaltiesInfographicStep as t };